import React from 'react';
import OrderDetail from '../component/Order';

const OrderDetailPage = () => {
    return <OrderDetail />;
};

export default OrderDetailPage;
